import { motion } from "framer-motion";
import { FileText, Building2, Landmark, Scale, Briefcase, Award, Video } from "lucide-react";

const SERVICES = [
  {
    icon: FileText,
    title: "Documentation & Conveyancing",
    text: "Form F, developer NOC, escrow coordination and DLD trustee-office transfer — every paper checked against RERA rules before you sign.",
  },
  {
    icon: Building2,
    title: "Property Management",
    text: "Tenant acquisition, lease renewals, maintenance requests, property inspections and holiday-home services — your asset, cared for.",
  },
  {
    icon: Landmark,
    title: "Mortgage Financing",
    text: "Pre-approval strategy, bank comparison and First-Time Home Buyer packages matched to your profile.",
  },
  {
    icon: Scale,
    title: "Property Evaluation",
    text: "Independent market valuations and rental assessments so you never overpay — or undersell.",
  },
  {
    icon: Briefcase,
    title: "Investment Portfolio Management",
    text: "Off-plan entry strategy, yield modelling, restructuring and exit planning across your Dubai holdings.",
  },
  {
    icon: Award,
    title: "Insurance Services",
    text: "Home, contents and landlord protection arranged through trusted UAE insurers.",
  },
  {
    icon: Video,
    title: "Virtual Viewings",
    text: "Live Zoom walkthroughs of shortlisted properties — wherever in the world you are.",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-20 lg:py-32 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="max-w-2xl"
      >
        <p className="text-xs uppercase tracking-[0.35em] text-gold-light/90 font-medium mb-6">What we do</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F8F6F0] leading-tight">
          Upscale living, <span className="italic gold-text">handled end to end.</span>
        </h2>
      </motion.div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: Math.min(i * 0.06, 0.4), duration: 0.6 }}
            className={`gold-ring rounded-2xl p-7 bg-ink-card/60 hover:bg-ink-hover transition-all duration-300 group ${
              i === 1 ? "lg:row-span-2 flex flex-col" : ""
            }`}
            data-testid={`service-card-${i + 1}`}
          >
            <div className="w-11 h-11 rounded-xl bg-gold/10 border border-gold/25 flex items-center justify-center group-hover:bg-gold/20 transition-colors">
              <s.icon size={20} className="text-gold" />
            </div>
            <h3 className="mt-5 font-serif text-xl text-[#F8F6F0]">{s.title}</h3>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
            {i === 1 && (
              <ul className="mt-5 space-y-2.5 text-xs text-zinc-400 flex-1">
                {["Tenant acquisition & screening", "Lease renewals & Ejari registration", "24/7 maintenance coordination", "Quarterly property inspections", "Holiday-home setup & guest management"].map((li) => (
                  <li key={li} className="flex items-center gap-2.5">
                    <span className="w-1 h-1 rotate-45 bg-gold shrink-0" /> {li}
                  </li>
                ))}
              </ul>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
